/**
 * INBAR+co — XO AndBloom Page Scripts
 * File: assets/inbar-xo.js
 *
 * Depends on: assets/inbar-concerns.js (icAddToCart, global icToggleKit)
 *
 * Handles:
 * - Hero product switcher (thumb click → swap main image + body copy)
 * - Protocol step accordion (click row to expand/collapse note)
 * - Sticky ATC bar (show/hide based on scroll + kit/closing CTA visibility)
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     SWITCHER
     Clicking a .ic-xo-sw-thumb swaps the main
     panel image, flag, type, name, copy, price
     and ATC variant ID.
  ───────────────────────────────────────────── */
  function initSwitcher() {
    var thumbs = document.querySelectorAll('.ic-xo-sw-thumb');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var photo   = document.getElementById('ic-xo-sw-photo');
        var flag    = document.getElementById('ic-xo-sw-flag');
        var type    = document.getElementById('ic-xo-sw-type');
        var name    = document.getElementById('ic-xo-sw-name');
        var copy    = document.getElementById('ic-xo-sw-copy');
        var price   = document.getElementById('ic-xo-sw-price');
        var atcBtn  = document.getElementById('ic-xo-sw-atc');

        if (!photo) return;

        // Fade out
        photo.style.opacity = '0';

        // Hide cover image on first thumb interaction
        var cover = document.getElementById('ic-xo-sw-cover');
        if (cover) { cover.style.display = 'none'; }

        setTimeout(function () {
          if (thumb.dataset.img)     { photo.src = thumb.dataset.img; photo.style.display = ''; }
          if (flag && thumb.dataset.flag)   { flag.textContent  = thumb.dataset.flag; }
          if (type && thumb.dataset.type)   { type.textContent  = thumb.dataset.type; }
          if (name && thumb.dataset.name)   { name.textContent  = thumb.dataset.name; }
          if (copy && thumb.dataset.copy)   { copy.textContent  = thumb.dataset.copy; }
          if (price && thumb.dataset.price) { price.textContent = thumb.dataset.price; }
          if (atcBtn && thumb.dataset.variant) {
            atcBtn.dataset.variantId = thumb.dataset.variant;
          }
          photo.style.opacity = '1';
        }, 220);

        // Active state
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }


  /* ─────────────────────────────────────────────
     PROTOCOL STEP ACCORDION
     Clicking a .ic-xo-step expands/collapses
     its .ic-xo-step__body.
     Does not toggle if user clicked a button or <a>.
  ───────────────────────────────────────────── */
  function initStepAccordion() {
    var stepList = document.getElementById('ic-xo-steps');
    if (!stepList) return;

    stepList.addEventListener('click', function (e) {
      // Ignore clicks on buttons and links inside the step
      if (e.target.closest('button') || e.target.closest('a')) return;

      var step = e.target.closest('.ic-xo-step');
      if (!step) return;

      var isOpen = step.classList.contains('open');

      // Close all
      stepList.querySelectorAll('.ic-xo-step').forEach(function (s) {
        s.classList.remove('open');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        step.classList.add('open');
      }
    });
  }


  /* ─────────────────────────────────────────────
     STICKY ATC BAR
     Shows after user scrolls past the hero.
     Hides when the kit showcase is in view (avoid
     duplicate buttons), and stays hidden once the
     closing CTA has come into view or scrolled past
     (user has reached the funnel end -- don't keep
     pestering on Other Concerns).
  ───────────────────────────────────────────── */
  function initStickyAtc() {
    var sticky = document.getElementById('ic-xo-sticky');
    if (!sticky) return;

    var hero    = document.querySelector('.ic-xo-hero');
    var kit     = document.querySelector('.ic-xo-kit');
    var closing = document.querySelector('.ic-xo-closing');

    function update() {
      // Past the hero?
      var heroPast = hero ? hero.getBoundingClientRect().bottom < 0 : true;
      // Kit ATC visible?
      var kitVisible = false;
      if (kit) {
        var kitRect = kit.getBoundingClientRect();
        kitVisible = kitRect.bottom > 80 && kitRect.top < window.innerHeight - 60;
      }
      // Closing CTA reached? (top has entered viewport OR fully passed)
      var closingReached = false;
      if (closing) {
        closingReached = closing.getBoundingClientRect().top < window.innerHeight - 60;
      }

      var show = heroPast && !kitVisible && !closingReached;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }


  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initSwitcher();
    initStepAccordion();
    initStickyAtc();
  });

})();
